import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { OptionsWithExclude } from 'components/common/MyCustomSelect/components/OptionsWithExclude/OptionsWithExclude';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const Tags = ({ options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();

    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Tags</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>, true>
                        id={'battlecards-filters-tags'}
                        {...field}
                        isMulti
                        options={options}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isClearable={true}
                        components={{
                            Option: OptionsWithExclude,
                        }}
                        isLoading={isLoading}
                    />
                )}
                name={`tags`}
                control={control}
            />
        </div>
    );
};
